import styled from 'styled-components';
import logo from "../assets/logos/logo.jpg";
import {VscMenu} from "react-icons/vsc";
import {ImWhatsapp} from "react-icons/im";
import {MdEmail, MdOutlineAccessTime} from "react-icons/md";
import {BiCaretDownCircle} from "react-icons/bi";
import { useEffect, useState } from 'react';
import {Link, useLocation} from "react-router-dom"


const Nav = () => {
    const [open, setOpen] = useState(false);
    const [down, setDown] = useState(false);
    const [scrollTop, setScrollTop] = useState(0);
    const location = useLocation().pathname;

    useEffect(()=> {
        setDown(false);
    },[location]);

    useEffect(() => {
        const deviceType = () => {
            const ua = navigator.userAgent;
            if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
                return "tablet";
            }
            else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
                return "mobile";
            }
            return "desktop";
        };
        const device = deviceType();

        if(open && device !== "desktop") {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "visible";
        }
    },[open]);

    window.addEventListener("scroll", ()=> {
        setScrollTop(window.pageXOffset || document.documentElement.scrollTop);
    });

    

  return (
    <>
    <FixedBtn onClick={() => setOpen(true)} scrollTop={scrollTop}><VscMenu /></FixedBtn>
    <Top>
        <Number><InfoIcon><ImWhatsapp /></InfoIcon> WhatsApp: (13) 99161-8326</Number>
        <Email><InfoIcon><MdEmail /></InfoIcon> contato@remoldserviços.com.br</Email>
    </Top>
    <Header>
        <Wrapper>
            <Logo src={logo} /> 
            <Line></Line>
            <Name> 
                <span style={{color: "#f2c70f", textShadow: "1px 1px #494544"}}>Remold</span> <br /> Serviços
            </Name>
        </Wrapper>
        <Icon onClick={()=> setOpen(true)}><VscMenu /></Icon>
    </Header>

    <NavBar open={open}>
        <Ul>
            <X open={open} onClick={()=> setOpen(false)}>X</X>
            <Link onClick={()=> setOpen(false)} style={link} to={"/"}>
                <Li location={location === "/" ? true : false}>Home</Li>
            </Link>
            <Link onClick={()=> setOpen(false)} style={link} to={"/empresa"}>
                <Li location={location === "/empresa" ? true : false}>Empresa</Li>
            </Link>

            <div style={{display: "flex", alignItems: "center", borderBottom: "1px solid #ffffff1a"}}>

                <Link  onClick={()=> setOpen(false)} style={{width: "100%", textDecoration: "none", color: "inherit"}} to={"/serviços"}>
                    <Li down={true} location={location === "/serviços" ? true : false}>Serviços </Li> 
                </Link>
                <DownIcon down={down} onClick={() => setDown(!down)}><BiCaretDownCircle /></DownIcon>

            </div>

            <SubLiWrapper down={down}>
                <Link onClick={()=> setOpen(false)} style={link} to={"/serviços/residencial"}>
                    <SubLi location={location === "/serviços/residencial" ? true : false}>Manutenção Residencial</SubLi>
                </Link>
                <Link onClick={()=> setOpen(false)} style={link} to={"/serviços/predial"}>
                    <SubLi location={location === "/serviços/predial" ? true : false}>Manutenção Predial</SubLi>
                </Link>
                <Link onClick={()=> setOpen(false)} style={link} to={"/serviços/condominio"}>
                    <SubLi location={location === "/serviços/condominio" ? true : false}>Manutenção de Condomínio</SubLi>
                </Link>
            </SubLiWrapper>

            <Link onClick={()=> setOpen(false)} style={link} to={"/contato"}>
                <Li  location={location === "/contato" ? true : false}>Contato</Li>
            </Link>
           
          

            <BottomInfo>
                <BottomInfoIcon><MdOutlineAccessTime /></BottomInfoIcon> Seg à Sex das 08h às 18h
            </BottomInfo>
        </Ul>
    </NavBar>

    <BlackScreen onClick={()=> setOpen(false)} open={open}></BlackScreen>
    </>
  )
}

const link = {
    textDecoration: "none",
    color: "inherit"
}

const FixedBtn = styled.div`
    background-color: rgba(0,0,0,.2);
    color: #fff;
    font-size: 1.9rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    border-radius: 5px;
    width: fit-content;
    box-shadow: 2px 2px 5px #0000006f;
    position: fixed;
    top: 20px;
    right: 20px;
    cursor: pointer;
    z-index: 750;

    transition: opacity 250ms linear;
    visibility: ${props => props.scrollTop >= 200 ? "visibility" : "hidden"};
    opacity: ${props => props.scrollTop >= 200 ? 1 : 0};

    @media (min-width: 780px) {
        right: 10px;
        font-size: 2rem;
        padding: 8px;
    }
`;

const Top = styled.div`
    background-color: #494544;
    color: #fff;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: end;
    padding: 0 50px;
    font-weight: 300;
    font-size: 1rem;
    display: none;

    @media (min-width: 580px) {
        display: flex;
    }
`;

const Number = styled.div`
    margin-right: 30px;
    display: flex;
    align-items: center;
`;

const Email = styled.div`
    display: flex;
    align-items: center;
`;

const InfoIcon = styled.div`
    color: #f2c70f;
    font-size: 1.1rem;
    margin-top: 5px;
    margin-right: 8px;
`;

const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 100px;
    background-color: #fff;
    border-bottom: 1px solid #49454422;
    /* border-bottom: 40px solid #f2c70f; */
    box-shadow: 0px 0px 5px rgb(0 0 0 / 20%);
    @media (min-width: 780px) {
        height: 120px;
        padding: 0 50px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    /* margin-bottom: -40px; */
`;

const Logo = styled.img`
    border-radius: 50%;
    object-fit: cover;
    height: 60px;
    width: 60px;

    @media (min-width: 780px) {
        height: 80px;
        width: 80px;
    }
`

const Line = styled.div`
    background-image: linear-gradient( #f2c70f, #494544);
    height: 70px;
    width: 3px;
    border-radius: 50px;
    margin: 0 15px;

    @media (min-width: 780px) {
        height: 80px;
    }
`;

const Name = styled.h2`
    color: #494544;
    text-transform: uppercase;
    line-height: 2.3rem;
    /* font-size: 2.2rem; */
    font-size: 1.8rem;
    font-weight: 700;
    font-style: italic;
    text-shadow: 1px 1px 0px #f2c70f;

    @media (min-width: 780px) {
        font-size: 2.5rem;
    }
`

const Icon = styled.div`
    color: #494544;
    cursor: pointer;
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    /* margin-bottom: -40px; */

`;

//NavBar section

const NavBar = styled.nav`
    background-color: #494544;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 320px;
    transition: transform 250ms ease-out;
    transform: translate(${props => props.open ? 0 : "-100%"});
    z-index: 999;
`;

const Ul = styled.ul`
    list-style: none;
    padding: 0 20px;
`;

const X = styled.div`
    color: #fff;
    background-color: #f2c70f;
    width: fit-content;
    padding: 5px 10px;
    font-weight: 900;
    margin-left: auto;
    margin-right: -20px;
    cursor: pointer;
    border-bottom-left-radius: 1px;
    border-bottom-right-radius: 1px;
    text-shadow: 1px 1px 0 black;
    font-size: 1.2rem;

    @media (min-width: 780px) {
        font-size: 1rem;
    }

    transition: opacity 250ms linear 400ms;
    opacity: ${props => props.open ? 1 : 0};
  

    &:hover {
        color: #f2c70f;
        background-color: #fff;
    }
`;

const Li = styled.li`
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    padding: 20px 0;
    color: ${props => props.location ? "#f2c70f" : "#fff"};
    border-bottom: 1px solid #ffffff1a;
    width: 100%;
    border-bottom: ${props => props.down && "0px"};

    @media (min-width: 780px) {
        padding: 15px 0;
        font-weight: 300;
    }

    &:hover {
        color: #f2c70f;
    }
`;

const SubLiWrapper = styled.div`
  overflow: hidden;
  transition: all 250ms linear;
  height: ${props => props.down ? "123px" : "0"};
`;


const SubLi = styled.li`
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 2px;
    text-transform: uppercase;
    /* padding: 15px 0; */
    line-height: 40px;
        
    padding-left: 5px;
    margin-left: 15px;
    color: ${props => props.location ? "#f2c70f" : "#fff"};
    border-bottom: 1px solid #f2c80f44;

    @media (min-width: 780px) {
        /* padding: 10px 0; */
        padding-left: 5px;
        font-weight: 500;
        margin-left: 15px;
    }

    &:hover {
        color: #f2c70f;
    }
`;

const DownIcon = styled.div`
    color: #ffffffac;
    font-size: 1.5rem;
    cursor: pointer;
    color: ${props => props.down ? "#f2c70f" : "#ffffffac"};

    @media (min-width: 780px) {
        &:hover {
            color: #f2c70f;
        }
    }
`;


const BottomInfo = styled.div`
    position: absolute;
    left: 0px;
    bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    color: #f2c70f;
    font-size: 1.1rem;
    font-weight: 400;

`;

const BottomInfoIcon = styled.div`
    color: #fff;
    font-size: 1.1rem;
    margin-top: 6px;
    margin-right: 8px;
`;

//black screen
const BlackScreen = styled.div`
    background-color: #0000007f;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    transition: opacity 250ms linear;
    visibility: ${props => props.open ? "visible" : "hidden"};
    opacity: ${props => props.open ? 1 : 0};
    z-index: 800;
`;

export default Nav